/** Support email used in translations interpolation */
const supportEmail = 'support@bkbn.com'
export default supportEmail